/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["table[_ngcontent-%COMP%]{width:100%;border-width:0;font-size:14px;border-spacing:0;padding-top:10px}table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:3px}thead[_ngcontent-%COMP%]{background-color:#3f51b5;color:#fff}div.comment-row[_ngcontent-%COMP%]{display:flex;flex-direction:row}.old[_ngcontent-%COMP%]{font-weight:600}\n/*# sourceMappingURL=feature-flag-details.component.css.map*/"];
export { styles as styles };
